// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4fb9c203","498":"7e6bad0f","703":"0f75cbf5"}[chunkId] + ".chunk.js";
};